import React from 'react';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getVisiblePages = () => {
    const pages = [];
    const addPage = (page) => {
      if (page >= 1 && page <= totalPages && !pages.includes(page)) {
        pages.push(page);
      }
    };

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) addPage(i);
    } else {
      addPage(1);
      addPage(2);
      addPage(3);

      if (currentPage > 5) pages.push('...');

      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        if (i > 3 && i < totalPages) addPage(i);
      }

      if (currentPage < totalPages - 2) pages.push('...');
      addPage(totalPages);
    }

    return pages;
  };

  return (
    <nav aria-label="Pagination">
      <ul className="pagination justify-content-end">
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button
            className="page-link"
            disabled={currentPage === 1}
            onClick={() => onPageChange(currentPage - 1)}
          >
            Previous
          </button>
        </li>

        {getVisiblePages().map((page, idx) =>
          page === '...' ? (
            <li key={idx} className="page-item disabled">
              <span className="page-link">…</span>
            </li>
          ) : (
            <li key={idx} className={`page-item ${page === currentPage ? 'active' : ''}`}>
              <button className="page-link" onClick={() => onPageChange(page)}>{page}</button>
            </li>
          )
        )}

        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button
            className="page-link"
            disabled={currentPage === totalPages}
            onClick={() => onPageChange(currentPage + 1)}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
